var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-submenu',{attrs:{"index":_vm.taskId}},[_c('template',{slot:"title"},[_vm._v(_vm._s(_vm.topTitle))]),_vm._l((_vm.rfidConfig.allPackageTypes),function(item,idx){return _c('el-menu-item',{key:idx,attrs:{"index":`${_vm.taskId}-${_vm.scanType}-${item.value}`,"disabled":_vm.disabled}},[_vm._v(_vm._s(item.label)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }